export default __webpack_public_path__ + "static/media/B83.72df5c08.png";